const rankings = [
  { rank: 1, title: '流光之城', type: '电视剧', hot: '986万热度', change: 'up', desc: '都市情感大剧，演技派阵容倾情演绎' },
  { rank: 2, title: '暗夜追踪III', type: '电视剧', hot: '872万热度', change: 'up', desc: '悬疑烧脑续作，口碑持续走高' },
  { rank: 3, title: '星际迷航：新纪元', type: '电影', hot: '765万热度', change: 'new', desc: '科幻巨制，4K修复版震撼上线' },
  { rank: 4, title: '山河纪行V', type: '纪录片', hot: '653万热度', change: 'same', desc: '自然探索纪录片，视听双重享受' },
  { rank: 5, title: '夏日奇遇记', type: '综艺', hot: '598万热度', change: 'down', desc: '暑期特别企划，欢乐不断档' },
  { rank: 6, title: '仙途问道', type: '动漫', hot: '542万热度', change: 'up', desc: '国风仙侠动画，画面精美绝伦' },
];

const changeIcon = (change: string) => {
  if (change === 'up') return <i className="ri-arrow-up-line text-green-400 text-xs"></i>;
  if (change === 'down') return <i className="ri-arrow-down-line text-red-400 text-xs"></i>;
  if (change === 'new') return <span className="text-xs font-bold text-primary-400">NEW</span>;
  return <i className="ri-subtract-line text-foreground-400 text-xs"></i>;
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full border border-accent-500/20 mb-3">
            热度榜单
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide">
            排行榜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            实时热度排行，发现大家都在看什么
          </p>
        </div>

        <div className="space-y-2 md:space-y-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 bg-background-100 rounded-lg border border-background-200/60 p-3 md:p-4 hover:border-primary-500/20 transition-all duration-300 cursor-pointer group"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 flex-shrink-0 flex items-center justify-center rounded-lg font-bold text-sm md:text-base ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-400 transition-colors duration-200 truncate">
                    {item.title}
                  </h3>
                  <span className="text-[10px] md:text-xs text-foreground-500 bg-background-200 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm md:text-base font-bold text-accent-400 whitespace-nowrap">{item.hot}</span>
                <span className="w-5 h-5 flex items-center justify-center">{changeIcon(item.change)}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#cards"
            className="inline-flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors duration-200 cursor-pointer no-underline"
          >
            查看完整榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}